import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {IRelay} from "../../store/sliceWebsocket";
import {RelayArticle, RelayFormCheck, RelayImg, RelayText} from "./RelayStyle";
import {FormCheck} from "react-bootstrap";
import {fetchToggleRelay} from "../../fetch/DeviceRequest";
import relay from "../../image/relay.webp"


interface RelayProps {
    deviceId: string
}

const Relay: FC<RelayProps> = ({deviceId}) => {
    const dispatch = useDispatch<AppDispatch>();
   const [status, setStatus] = useState('')
    const iRelay: IRelay = useSelector((state: IRootState) => state.websocket.relays.filter((relay: IRelay) => relay.deviceId === deviceId)[0])

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (iRelay?.state == "ON") {
                setStatus('Включен')
                return
            }
            if (iRelay?.state == "OFF") {
                setStatus('Выключен')
                return;
            }
            setStatus('Оффлайн')
        }, 300)

        return () => clearTimeout(timeoutId);

    }, [iRelay?.state])

    const toggle = useCallback(() => {
        fetchToggleRelay(iRelay.deviceId)
    }, [iRelay.deviceId, iRelay?.state])

    return (
        <RelayArticle>
            <RelayImg src={relay} alt={"Реле"}/>
            {iRelay?.location && <RelayText>{iRelay?.location}</RelayText>}
            {!iRelay?.location && <RelayText>--</RelayText>}
            <RelayFormCheck // prettier-ignore
                disabled={status == 'Оффлайн'}
                disable
                type="switch"
                id="custom-switch"
                onChange={toggle}
                checked={iRelay.state === 'ON'}
            />
            <RelayText>{status}</RelayText>
        </RelayArticle>
    )
}

export default memo(Relay)

